import Decimal from 'decimal.js';

import { toBN } from '@utils/formaters.utils';
import { isAddressesEqual } from '@utils/tokens.utils';

import { CHAIN_ID, ZERO_ADDRESS } from '@constants/common/chain.constants';
import {
  AssetType,
  TOKENS,
  TokenSymbol,
} from '@constants/common/tokens.constants';

import { ExtendedToken } from '@dto/contracts/etfs/common.dto';

import { AssetToken } from '@app-types/common/token.types';

export const updateTokens = (tokens: ExtendedToken[], chainId: number) =>
  tokens.map((token) => {
    const { address } = TOKENS[CHAIN_ID.ARBITRUM][TokenSymbol.USDC];

    if (
      isAddressesEqual(token.address, address) &&
      toBN(chainId).equals(CHAIN_ID.ARBITRUM)
    ) {
      return { ...token, symbol: 'USDC.e' };
    }
    return token;
  });

type FieldConfig = { field: string };

export const mapDataToFields = <T>(
  data: any[],
  configs: readonly FieldConfig[],
  initialObject: Partial<T> = {},
): T =>
  configs.reduce(
    (result, config, index) => {
      if (config.field && index < data.length) {
        result[config.field as keyof T] = data[index];
      }
      return result;
    },
    { ...initialObject } as T,
  );

interface MintBurnTokensParams {
  chainId: number;
  zapperTokens: ExtendedToken[];
  zapperNativeToken: ExtendedToken | null;
  zapperNativeBalance: Decimal;
}

export const normalizeMintBurnTokens = ({
  zapperTokens,
  chainId,
  zapperNativeBalance,
  zapperNativeToken,
}: MintBurnTokensParams): AssetToken[] => {
  const zapperErc20Tokens = zapperTokens.filter(
    (item) => !isAddressesEqual(item.address, ZERO_ADDRESS),
  );

  const normalizedZapperErc20Tokens: AssetToken[] = zapperErc20Tokens.map(
    ({ address, symbol, balance, decimals }) => ({
      address,
      symbol,
      icons: [{ address, chainId }],
      tokenId: null,
      fee: null,
      assetType: AssetType.Zapper,
      balance,
      decimals,
      priceInUsd: null,
    }),
  );

  const normalizedZapperNativeToken: AssetToken | null = zapperNativeToken
    ? {
        address: zapperNativeToken.address,
        symbol: zapperNativeToken.symbol,
        tokenId: null,
        fee: null,
        icons: [{ address: zapperNativeToken.address, chainId }],
        assetType: AssetType.Zapper,
        balance: zapperNativeBalance,
        decimals: zapperNativeToken.decimals,
        priceInUsd: null,
      }
    : null;

  if (!normalizedZapperErc20Tokens.length && !normalizedZapperNativeToken)
    return [];

  // const isIncludeNative = normalizedZapperErc20Tokens.some((item) => (
  //   isAddressesEqual(item.address || '', normalizedZapperNativeToken?.address || '')
  // ));

  const allTokens = normalizedZapperNativeToken
    ? [normalizedZapperNativeToken, ...normalizedZapperErc20Tokens]
    : [...normalizedZapperErc20Tokens];

  return allTokens.sort((a, b) =>
    toBN(toBN(b.balance || 0))
      .minus(toBN(toBN(a.balance || 0)))
      .toNumber(),
  );
};
